import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { EmphasisTag } from '@wtag/react-comp-lib';
import Button from '@wtag/rcl-button';
import Icon from '@wtag/rcl-icon';
import ConfirmationModal from 'sharedWebpack/ConfirmationModal';
import getJourneyDateRange from 'sharedWebpack/helpers/getJourneyDateRange';
import FlightRoute from '../../FlightRoute';
import redirectToOrderItem from '../../../../../../helpers/redirectToOrderItem';

const HeaderTop = ({ startDate, endDate, itemPath, originInfo, destinationInfo }) => {
  const [isCancelChangeModalOpen, setIsCancelChangeModalOpen] = useState(false);
  const journeyDates = getJourneyDateRange(startDate, endDate);

  const onCancelChangeModalOpen = () => {
    setIsCancelChangeModalOpen(true);
  };

  const onCancelChangeModalClose = () => {
    setIsCancelChangeModalOpen(false);
  };

  const subHeaderContent = (
    <div className="flight-exchange-header__cancel-modal--subheader">
      <div>{I18n.t('components.flight.exchange.modal.cancel_change.subheader')}</div>
      <div>{I18n.t('components.flight.exchange.modal.confirmation_prompt')}</div>
    </div>
  );

  return (
    <div className="d-flex justify-between align-center flex-wrap row-gap-8">
      <div className="d-flex align-center flex-gap-8 flex-wrap flex-grow">
        <EmphasisTag
          text={I18n.t('components.flight.exchange.tag.current_item')}
          type="success"
          size="tiny"
        />
        <FlightRoute
          originInfo={originInfo}
          destinationInfo={destinationInfo}
          styleVariant="boldLarge"
        />
        <Icon name="today" size="small" />
        <div className="flight-exchange-header__travel-date">{journeyDates}</div>
      </div>
      <Button
        className="flight-exchange-header__action--cancel"
        size="small"
        label={I18n.t('components.flight.exchange.action.cancel')}
        onClick={onCancelChangeModalOpen}
      />
      <ConfirmationModal
        className="flight-exchange-header__cancel-modal"
        isModalOpen={isCancelChangeModalOpen}
        confirmationHeader={I18n.t('components.flight.exchange.modal.cancel_change.header')}
        subHeader={subHeaderContent}
        withAction={true}
        type="danger"
        onConfirm={() => {
          redirectToOrderItem(itemPath);
        }}
        onReject={onCancelChangeModalClose}
      />
    </div>
  );
};

HeaderTop.defaultProps = {
  startDate: null,
  endDate: null,
  originInfo: {},
  destinationInfo: {},
};

HeaderTop.propTypes = {
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  itemPath: PropTypes.string.isRequired,
  originInfo: PropTypes.shape({
    placeName: PropTypes.string,
    countryName: PropTypes.string,
  }),
  destinationInfo: PropTypes.shape({
    placeName: PropTypes.string,
    countryName: PropTypes.string,
  }),
};

export default HeaderTop;
